<template>
	<div class="project rounded-3 mx-2 overflow-hidden" :class="{ 'backInvisible': !display, 'shadow' : display }">
		<div class="p-5 projectImage position-relative" :class="{ 'scaleAway': !display }" :style="{
			'background-image': `radial-gradient(rgba(0,0,0,.1), rgba(0,0,0,.6)), url(${ (project.icon) ? project.icon : project.image})`
		}">
			<div class="p-5">
				<div class="p-5"></div>
			</div>
            <span class="badge bg-dark position-absolute m-2 shadow rounded-2 bottom-0 start-0">{{project.name}}</span>
		</div>
	</div>
</template>
<script>
export default {
	name: "ProjectCard",
	props: {
		project: Object,
        display: Boolean
	}
}
</script>
<style scoped>
.project {
    background-color: rgba(33, 37, 41, 1);
    transition: 300ms !important;
}
.projectImage {
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}
.scaleAway {
    animation-name: scaleAway;
    animation-duration: 500ms;
    animation-fill-mode: forwards;
    transform-origin: center;
}
.backInvisible {
    animation-name: backInvisible;
    animation-duration: 500ms;
    animation-fill-mode: forwards;
    transform-origin: center;
}

@keyframes scaleAway {
    from {
        transform: scale(100%);
    }
    to {
        transform: scale(0%);
    }
}
@keyframes backInvisible {
    0% {
        background-color: rgba(33, 37, 41, 1);
    }
    50% {
        background-color: rgba(33, 37, 41, 0);
    }
    51% {
        
    }
    100% {
        width: 0%;
    }
}
</style>